import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { AdminHeaderComponent } from './components/admin-header/admin-header.component';
import { SuccessComponent } from './modals/success/success.component';
import { ErrorComponent } from './modals/error/error.component';
import { ResponseComponent } from './modals/response/response.component';
import { LoadingSpinnerComponent } from './modals/loading-spinner/loading-spinner.component';
import { UpdateApplicationStatusComponent } from './modals/update-application-status/update-application-status.component';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpdatePreenlistmentStatusComponent } from './modals/update-preenlistment-status/update-preenlistment-status.component';
import { PreEnlistmentSuccessComponent } from './modals/pre-enlistment-success/pre-enlistment-success.component';
import { PreEnlistmentFailedComponent } from './modals/pre-enlistment-failed/pre-enlistment-failed.component';
import { ClearanceFailedComponent } from './modals/clearance-failed/clearance-failed.component';
import { ClearanceSuccessComponent } from './modals/clearance-success/clearance-success.component';
import { ClearanceReviewComponent } from './modals/clearance-review/clearance-review.component';
import { ClearanceRequestComponent } from './modals/clearance-request/clearance-request.component';
import { CurriculumSuccessComponent } from './modals/curriculum-success/curriculum-success.component';
import { CurriculumFailedComponent } from './modals/curriculum-failed/curriculum-failed.component';
import { EnrollmentSubmittedComponent } from './modals/enrollment-submitted/enrollment-submitted.component';
import { StudentFilterComponent } from './modals/student-filter/student-filter.component';
import { AssignStudentScheduleConfirmComponent } from './modals/assign-student-schedule-confirm/assign-student-schedule-confirm.component';
import { SelectionModalComponent } from './modals/selection-modal/selection-modal.component';
import { CreateScheduleDetailsConfirmComponent } from './modals/create-schedule-details-confirm/create-schedule-details-confirm.component';
import { CreateEmployeeComponent } from './modals/create-employee/create-employee.component';
import { AddGradesComponent } from './modals/add-grades/add-grades.component';
import { AddGradeComponent } from './modals/add-grade/add-grade.component';
import { UpdateEmployeeComponent } from './modals/update-employee/update-employee.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
    SuccessComponent,
    ErrorComponent,
    ResponseComponent,
    LoadingSpinnerComponent,
    UpdateApplicationStatusComponent,
    UpdatePreenlistmentStatusComponent,
    PreEnlistmentSuccessComponent,
    PreEnlistmentFailedComponent,
    ClearanceFailedComponent,
    ClearanceSuccessComponent,
    ClearanceReviewComponent,
    ClearanceRequestComponent,
    CurriculumSuccessComponent,
    CurriculumFailedComponent,
    EnrollmentSubmittedComponent,
    StudentFilterComponent,
    AssignStudentScheduleConfirmComponent,
    SelectionModalComponent,
    CreateScheduleDetailsConfirmComponent,
    CreateEmployeeComponent,
    AddGradesComponent,
    AddGradeComponent,
    UpdateEmployeeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    MatDatetimepickerModule,
    MatNativeDatetimeModule,
    MatDatepickerModule,
    NgxMatTimepickerModule.setLocale('en-GB'),
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
    PreEnlistmentSuccessComponent,
    PreEnlistmentFailedComponent,
    ClearanceFailedComponent,
    ClearanceSuccessComponent,
    ClearanceReviewComponent,
    ClearanceRequestComponent,
    CurriculumSuccessComponent,
    CurriculumFailedComponent,
    EnrollmentSubmittedComponent
  ]
})
export class SharedModule { }
